<template>
    <div
        v-if="visible"
        class="progress"
    >
        <div
            :style="styleObject"
            class="progress__inner"
        ></div>
    </div>
</template>

<script>
    export default {
        name: 'AppProgress',
        computed: {
            styleObject () {
                return {
                    width: this.percent + '%'
                }
            },
            visible () {
                return !this.$store.getters.isStepsDone;
            },
            amountDone () {
                return this.$store.getters.getMessagesByState('yes').length + this.$store.getters.getMessagesByState('no').length;
            },
            amountAll () {
                return this.$store.state.messages.list.length;
            },
            percent () {
                return this.amountAll
                    ? Math.round(100 * this.amountDone / this.amountAll)
                    : 0;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .progress {
        position: fixed;
        width: 100%;
        height: 4px;

        &__inner {
            background: green;
            height: 4px;
        }
    }
</style>